import React, { Component } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import { Container, Col } from 'reactstrap';

import './merchants.css'

class MerchantSuccess extends Component {
  componentDidMount() {
    document.title = "Payouts settings saved - Bamboo";
  }

  render() {
    return (
      <Container className="merchants">
          {
            this.context.authUser
            ? ""
            : <Redirect to="/merchant/login"/>
          }

          <Col sm="8" xs="8" md={{ size: 6, offset: 3 }} className="signup-form">
            <h2 className="text-center pt-3">Thank you!</h2>
            <hr/>

            <p className="pt-2">You’ve set up weekly payouts with Bamboo.</p>
            <p>If you have any queries you can get in touch with us at <a href="mailto:hello@bambooapp.ie">hello@bambooapp.ie</a></p>

            <br/>
          </Col>
      </Container>
    );
  }
}

MerchantSuccess.contextTypes = {
  authUser: PropTypes.object,
  userId: PropTypes.string
};

export default MerchantSuccess;
